// Libraries
import {
  Directive,
  Input,
  HostListener,
} from '@angular/core';

// Directives
import { ItemDirective } from './item.directive';

/**
 * `ItemToggleDirective` handles click event and execute toggle functionality for item parent element.
 */
@Directive({
  selector: '[wpItemToggle]'
})
export class ItemToggleDirective {
  // Public properties
  /**
   * Event name. Possible values: 'toggle', 'open', 'close'.
   */
  @Input()
  eventName = 'toggle';

  /**
   * Bind click event to element
   */
  @HostListener('click', ['$event.target']) onClick(target: any) {
    // Handles click event
    this.onClickTarget(target);
  }

  /**
   * Creates an instance of ItemToggleDirective.
   */
  constructor(
    public item: ItemDirective
  ) {}

  // Public methods
  /**
   * Handles target click event.
   */
  onClickTarget(target: any) {
    // Exit if item body is not set
    if (!this.item || !this.item.itemBody) {
      return;
    }
    // Check event name
    switch (this.eventName) {
      case 'open':
        this.item.itemBody.open();
        break;
      case 'close':
        this.item.itemBody.close();
        break;
      case 'toggle':
        this.item.itemBody.toggle();
        break;
    }
  }
}
